import ProcessActionRoutes from '../constants/process_action_routes';
import RestClient from '../../rest_client/rest_client.js';
import { HOST_NAME_API } from '../../../../../shared/serverInfo'

export const execute = (_processIds) => {	
	const url = `${HOST_NAME_API}${ProcessActionRoutes.GET_PROCESS_INSTANCE_DATA}`;
	const processIds = _processIds;

	return new Promise((resolve, reject) => {
		return RestClient.get(url, processIds)
			.then(handleLoadSuccess.bind(this, resolve, reject))
			.catch(reject);
	});
};

const handleLoadSuccess = (resolve, reject, response) => {
	const resources = response.entity;
	if (!resources) reject(response);

	resolve(resources);
};

export default {
	execute
};
